export default __webpack_public_path__ + "static/media/login-bg-1280.d02f6969.jpg";